import { RouteObject } from "react-router-dom";

const fallbackRoutes: RouteObject[] = [{ path: "*", lazy: () => import("@/pages/NotFoundPage") }];

export default fallbackRoutes;
